import { Modal } from "@pickit/pickit-components";
import "./WorkzoneModal.scss";
import { Field, Form, FormSpy } from "react-final-form";
import { NumericInput } from "component/inputs/NumericInput";
import { Button } from "@pickit/pickit-components";
import moment from "moment";
import { WorkzoneDetailType } from "sagas/types/regions";
import { WorkzoneModalPropsType } from "./types";
import "./i18n";
import { useTranslation } from "react-i18next";
import { DATE_FORMATS } from "utils/constants";
import { useEffect } from "react";

export const WorkzoneModal = ({
  formRef,
  isOpen,
  onSubmit,
  actualRegion,
  testId,
  onClose,
  setDirty,
}: WorkzoneModalPropsType): JSX.Element => {
  const { t } = useTranslation();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (isOpen) {
      params.set('modal', 'modify-quantity');
    } else {
      params.delete('modal');
    }
    const paramsString = params.toString();
    const newUrl = paramsString ? `${window.location.pathname}?${paramsString}` : window.location.pathname;
    window.history.pushState({}, '', newUrl);
  }, [isOpen]);

  return (
    <Modal width="1190px" height={`496px`} isOpen={isOpen} onClose={onClose} testId={testId}>
      <div className="modal-workzones-container">
        <div className="container-workzone-header-row modal-workzone-title">
          <div className="container-workzone-header-col-sm-5 pl-0">
            <h2 data-testId={`${testId}-transactions-title`}>
              {t("workzones:transactions")}
            </h2>
          </div>
          <div className="container-workzone-header-col-sm-4">
            <div>
              <p className="region" data-testId={`${testId}-region-title`}>
                {t("workzones:region")}
              </p>
              <p data-testId={`${testId}-region-name`}>{actualRegion?.name}</p>
            </div>
          </div>

          <div className="container-workzone-header-col-sm-3 end">
            <div className="date-container">
              <p className="region" data-testId={`${testId}-date-title`}>
                {t("workzones:date")}
              </p>
              <p data-testId={`${testId}-date`}>
                {moment().format(DATE_FORMATS.shortDate)}
              </p>
            </div>
          </div>
        </div>

        <div className="workzone-title-container">
          <h1 data-testId={`${testId}-title`}>{t("workzones:indication")} </h1>
        </div>

        <Form
          initialValues={{}}
          onSubmit={(value) => {
            onSubmit({ id: actualRegion?.id, workzones: value });
          }}
        >
          {({ handleSubmit, form, dirty }) => {
            formRef.current = form;
            return (
              <form onSubmit={handleSubmit}>
                <FormSpy
                  subscription={{
                    dirty: true,
                  }}
                  onChange={(formState) => {
                    setDirty(formState.dirty);
                  }}
                />
                <div className="form-workzone">
                  <div className="container-workzone-form">
                    <div className="container-workzone-form-row header-row">
                      <div className="container-workzone-form-col-sm-1">
                        <div className="workzone-field">
                          <h2 data-testId={`${testId}-workzones-title`}>
                            {t("workzones:workzone")}
                          </h2>
                        </div>
                      </div>
                      <div className="container-workzone-form-col-sm-1">
                        <div className="workzone-field">
                          <h2 data-testId={`${testId}-actual-amount-title`}>
                            {t("workzones:actualAmount")}
                          </h2>
                        </div>
                      </div>
                      <div className="container-workzone-form-col-sm-1">
                        <div className="workzone-field">
                          <h2 data-testId={`${testId}-new-amount-title`}>
                            {t("workzones:newAmount")}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div className="modal-workzones-container-scroll">
                      <div className="container-workzone-form-row">
                        <div className="container-workzone-form-col-sm-1">
                          <div className="workzone-field">
                            {actualRegion &&
                              actualRegion?.workZones?.map(
                                (w: WorkzoneDetailType, index) => (
                                  <h3
                                    key={w.id}
                                    data-testId={`${testId}-workzone-${
                                      index + 1
                                    }-name`}
                                  >
                                    {w.name}
                                  </h3>
                                )
                              )}
                          </div>
                        </div>
                        <div className="container-workzone-form-col-sm-1">
                          <div className="workzone-field">
                            {actualRegion &&
                              actualRegion.workZones.map(
                                (w: WorkzoneDetailType, index) => (
                                  <h3
                                    key={w.id}
                                    data-testId={`${testId}-workzone-${
                                      index + 1
                                    }-actual-amount`}
                                  >
                                    {w.maxTransactions}
                                  </h3>
                                )
                              )}
                          </div>
                        </div>
                        <div className="container-workzone-form-col-sm-1">
                          <div className="inputs-container">
                            {actualRegion &&
                              actualRegion.workZones.map(
                                (w: WorkzoneDetailType, index) => (
                                  <div key={w.id}>
                                    <Field
                                      type="text"
                                      name={w.id}
                                      component={NumericInput}
                                      allowDecimal={false}
                                      maxInt={6}
                                      placeholder={t("workzones:enterNumber")}
                                      className="Admin-Pickers-input workzone-input"
                                      testId={`${testId}-${
                                        index + 1
                                      }-new-amount`}
                                      id={`${testId}-${
                                        index + 1
                                      }-new-amount`}
                                    />
                                  </div>
                                )
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Button
                    disabled={!dirty}
                    type="submit"
                    width="220"
                    hierarchy="primary"
                    size="medium"
                    testId={`${testId}-submit-button`}
                    label={t("global:confirm")}
                  />
                </div>
              </form>
            );
          }}
        </Form>
      </div>
    </Modal>
  );
};
